import { SNA_PREFIX } from '@services/utils'
import { useQuery } from '@tanstack/react-query'
import type { EquipmentList } from 'types/api'
import { apiClient } from '../api-client'

type UseEquipmentArgs = {
  search: string
}

type EquipmentPaginationResponse = {
  results: EquipmentList[]
  count: number
  limit: string | number
  offset: number
  next: string | null
  previous: string | null
}

export function useEquipment({ search }: UseEquipmentArgs) {
  const queryKey = ['equipment', search]

  async function getEquipment() {
    const params = new URLSearchParams()
    params.set('limit', '-1')
    if (search?.trim()) {
      params.set('search', search.trim())
    }

    const response = await apiClient.get<EquipmentPaginationResponse>(
      `${SNA_PREFIX}equipments?${params.toString()}`
    )
    return response.data.results
  }

  return useQuery({
    queryKey,
    queryFn: getEquipment
  })
}
